///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.brand_promo_campaigns = abcsetup.brand_promo_campaigns || {};
abcsetup.brand_promo_campaigns.workflow = abcsetup.brand_promo_campaigns.workflow || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.brand_promo_campaigns.workflow = {

    /**
     * Initialize event listeners and logic specific to workflow.
     */
    init: function() { 
        this.bindFormElems();
        $('.campaign-start-date').on('change', function(event) {
            var field = $(this);
            var start_date = field.val();
            var campaign_type = $('#campaign_type').val();

            if (!campaign_type) {
                campaign_type = abcsetup.brand_promo_campaigns.workflow.extractCampaignType();
            }

            // Check if the campaign is an advertisement
            if (abcsetup.brand_promo_campaigns.workflow._isAdvertisementCampaign(campaign_type)) {
                start_date = abcsetup.brand_promo_campaigns.workflow._enforceFirstDayOfMonth(field);
            }

            // Fetch campaign end date
            abcsetup.brand_promo_campaigns.workflow._getCampaignEndDate(start_date, campaign_type);
        });
    },

    bindFormElems: function () {
        var workflowDataElement = $('#WorkflowTask');  
    
        if (workflowDataElement.length && workflowDataElement.val()) {
            var workflowData = JSON.parse(workflowDataElement.val()); 
            var campaignTypeName = workflowData.for_entity.brand_promo_campaign_type.name;
            var taskName = workflowData.task;

            // Only run below logic for Advertisement campaigns
            if (campaignTypeName === 'Advertisement' && (taskName === 'supplier_submit_assets' || taskName === 'brand_team_review_promotion')) {
                // Select buttons and input fields related to spec sheet and PDF uploads for Advertisement campaigns
                var specSheetField = $("button[id='spec_sheet']");
                var pdfUploadField = $("button[id='pdf_upload']");
                var specSheetInput = $('input[name="spec_sheet"]');
                var pdfUploadInput = $('input[name="pdf_upload"]');
                var replaceLinks = $('a.btn-warning:contains("Replace")');

                // Set the correct file type acceptance and class for spec sheet and PDF upload inputs
                specSheetInput.attr('accept', 'image/jpeg');
                pdfUploadInput.attr('accept', 'application/pdf');

                // Check if replace links are available and set required attributes accordingly
                if (replaceLinks.length === 0) {
                    pdfUploadField.addClass("btn-required btn-danger required");
                    pdfUploadInput.attr('required', true);
                    specSheetField.addClass("btn-required btn-danger required");
                    specSheetInput.attr('required', true);
                }

                // General event handler for any "Replace" button
                replaceLinks.on('click', function(e) {
                    e.preventDefault();
        
                    // Set a delay to allow the input to be added to the DOM
                    setTimeout(function() {
                        var newPdfUploadInput = $('input[name="pdf_upload"]');
                        var newSpecSheetInput = $('input[name="spec_sheet"]');
                        
                        // Set the 'accept' attribute to allow only PDF files
                        if (newPdfUploadInput.length) {
                            console.log('newPdfUploadInput', newPdfUploadInput);
                            newPdfUploadInput.attr('accept', 'application/pdf');
                        } 
                        
                        // Set the 'accept' attribute to allow only Image/JPEG files
                        if (newSpecSheetInput.length) {
                            console.log('newSpecSheetInput', newSpecSheetInput);
                            newSpecSheetInput.attr('accept', 'image/jpeg');
                        }
                    }, 100);
                });

                pdfUploadInput.on('change', function() {
                    var file = this.files[0];
                    if (file) {
                        if (file.type !== 'application/pdf') {
                            $(this).val(''); 
                        } else {
                            // Remove "required" styling once a valid file is uploaded
                            specSheetField.removeClass("btn-required btn-danger required");
                            specSheetInput.attr('required', false);
                            specSheetInput.removeClass('invalid');
                            $(this).removeClass('invalid');
                            $('.text-danger').remove();
                        }
                    } else {
                        // Re-apply "required" styling if no file is selected and replace link is not present
                        if (replaceLinks.length === 0) {
                            pdfUploadField.addClass("btn-required btn-danger required");
                            pdfUploadInput.attr('required', true);
                            specSheetField.addClass("btn-required btn-danger required");
                            specSheetInput.attr('required', true);
                        }
                    }
                });

                specSheetInput.on('change', function() {
                    var file = this.files[0];
                    if (file) {
                        if (file.type !== 'image/jpeg') {
                            $(this).val(''); 
                        } else {
                            // Remove "required" styling once a valid file is uploaded
                            pdfUploadField.removeClass("btn-required btn-danger required");
                            pdfUploadInput.attr('required', false);
                            pdfUploadInput.removeClass('invalid');
                            $(this).removeClass('invalid');
                            $('.text-danger').remove();
                        }
                    } else {
                        // Re-apply "required" styling if no file is selected and replace link is not present
                        if (replaceLinks.length === 0) {
                            pdfUploadField.addClass("btn-required btn-danger required");
                            pdfUploadInput.attr('required', true);
                            specSheetField.addClass("btn-required btn-danger required");
                            specSheetInput.attr('required', true);
                        }
                    }
                });

                // Event handler for form submission to check that one of either fields is filled
                $(document).on('submit', 'form', function(e) {
                    // If the replace link exists, allow form submission regardless of the inputs
                    if (replaceLinks.length > 0) {
                        return true;  
                    }
                
                    // If there's no replace link, check the inputs
                    if (!pdfUploadInput.val() && !specSheetInput.val()) {
                        e.preventDefault(); 
                        return false;  
                    }
                
                    // If either pdfUploadInput or specSheetInput has a value, allow submission
                    return true;
                });
            } 

            if (campaignTypeName === 'Misc. Special Requests') {
                var specSheetInput = $('input[name="spec_sheet"]');
                var allowedFileTypes = [
                    'application/pdf',
                    'application/msword',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                    'image/jpeg',
                    'image/tiff',
                    'image/gif'
                ];
            
                specSheetInput.attr('accept', allowedFileTypes.join(', '));
            
                specSheetInput.on('change', function() {
                    var file = this.files[0]; 
                    if (file && !allowedFileTypes.includes(file.type)) {
                        alert('Invalid file type. Please upload a valid file (PDF, Word, JPEG, TIFF, or GIF).');
                        $(this).val(''); 
                    }
                });
            }
        } 
    },

    /**
     * Extracts the campaign type from the hidden #WorkflowTask input
     * 
     * @returns {string|null} - The campaign type key or null if not found
     */
        extractCampaignType: function() {
            var campaignType = null; 
            var workflowTaskValue = $('#WorkflowTask').val();
    
            if (workflowTaskValue) {
                try {
                    var workflowData = JSON.parse(workflowTaskValue);
    
                    if (workflowData.for_entity && workflowData.for_entity.brand_promo_campaign_type) {
                        campaignType = workflowData.for_entity.brand_promo_campaign_type.key || null;  
                    }
    
                } catch (error) {
                    console.error('Error parsing WorkflowTask JSON:', error);
                }
            }
    
            return campaignType;
        },

    /**
     * Enforces the start date to be the 1st of the selected month (in the format yyyy-MM).
     * 
     * @param {object} field - jQuery field element for start date
     * @return {string} - The start date adjusted to the first day of the selected month
     */
    _enforceFirstDayOfMonth: function(field) {
        var start_date = field.val();

        // Only retain the year and month (yyyy-MM format)
        var formattedDate = moment(start_date).startOf('month').format('YYYY-MM');
        
        // Set the field value to the new formatted date (yyyy-MM)
        field.val(formattedDate);

        return formattedDate;  // Return the new date for further use
    },

    /**
     * Check if the campaign is an advertisement
     * 
     * @param {string} campaign_type
     * @return {boolean}
     */
    _isAdvertisementCampaign: function(campaign_type) {
        return campaign_type === 'advertisement';
    },

    /**
     *  Get Campaign End Date based on type
     *
     * @param {string} start_date
     * @param {string} campaign_type
     */
    _getCampaignEndDate: function(start_date, campaign_type) {
        abcsetup.blockUI();
        console.log('start_date', start_date);

        axios.post('/api/brand_promos/get_campaign_end_date', { start_date: start_date, campaign_type: campaign_type })
            .then(response => {
                abcsetup.unblockUI();
                if (response.data) {
                    // Populate the end date fields if a valid response is received
                    if ($('.campaign-start-date').val() && $('.campaign-start-date').val().trim() !== '') {
                        $('.campaign-end-date').val(response.data.end_date);
                    } 

                    if ($('.ad-campaign-start-date').val() && $('.ad-campaign-start-date').val().trim() !== '') {
                        $('.campaign-end-date').val(response.data.end_date);
                    }
                }
            })
            .catch(error => {
                console.error('Error fetching campaign end date:', error);
                abcsetup.unblockUI();
                alert('There was an error retrieving the campaign end date. Please try again.');
            });
    },
}